import React from 'react';
import {
  Typography,
  useTheme,
} from "@mui/material";

function Header({ children, title, subtitle }) {
  const theme = useTheme();
  const color1 = theme.palette.secondary.main;
  const color2 = '#194721';

  return (
    <div className="content-header">
      <div className="content">
        {title && (
          <Typography variant="h1" className="header-title">
            {title}
          </Typography>
        )}

        {subtitle && (
          <Typography variant="h2" className="header-subtitle">
            {subtitle}
          </Typography>
        )}
        {children}
      </div>

      <svg
        style={{ marginBottom: '1rem' }}
        viewBox="0 0 1000 270"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1000 83C1000 130.886 947.322 176.811 853.553 210.672C759.785 244.533 632.608 263.556 500 263.556C367.392 263.556 240.215 244.533 146.447 210.672C52.6785 176.811 2.00233e-05 130.886 0 83L1000 83Z"
          fill={color2}
        />
        <rect width="1000" height="84" fill={color2} />
        <path
          d="M179.167 172.222C104.619 172.222 25.4984 143.519 0 83.3333V0H1000V84.7222C893.509 116.102 802.503 36.1111 648.122 36.1111C493.741 36.1111 353.019 172.222 179.167 172.222Z"
          fill={color1}
        />
      </svg>
    </div>
  );
}
export default Header;
